import type { FC } from "react";
import { Body, Heading, styled } from "@kivra/react-components";
import { FadeInAndOut } from "../atoms/FadeInAndOut";

interface HeaderBody {
  body?: string;
}

interface KivraHeaderProps extends HeaderBody {
  title: string;
}

const HeaderBody: FC<HeaderBody> = ({ body }) => (
  <StyledBody size="small">{body}</StyledBody>
);

export const KivraHeader: FC<KivraHeaderProps> = ({ title, body }) => (
  <FadeInAndOut>
    <StyledHeading size="large">{title}</StyledHeading>
    {body && <HeaderBody body={body} />}
  </FadeInAndOut>
);

const StyledHeading = styled(Heading)({
  textAlign: "center",
  marginTop: "$spacing-40",
  marginBottom: "$spacing-40",
});

const StyledBody = styled(Body)({
  marginBottom: "$spacing-40",
  textAlign: "center",
});
